import { createSlice } from "@reduxjs/toolkit";

const commentModerationSlice = createSlice({
    name: "commentModerationReducer",
    initialState: {
        commentModerationFilterLoading : false,
        commentModerationFilterData : null,
        commentModerationFilterError : null,

        commentModerationListLoading : false,
        commentModerationListData : null,
        commentModerationListError : null,

        commentModerationEditLoading : false,
        commentModerationEditData : null,
        commentModerationEditError : null,

        commentModerationSubmitLoading: false,
        commentModerationSubmitData: null,
        commentModerationSubmitError: null,

        message:null,

    },
    reducers: {
         //comment moderation filter
         getCommentModerationFilterLoading(state, action) {
            return {
                ...state,
                commentModerationFilterLoading: true,
            };
        },
        getCommentModerationFilterSuccess(state, action) {
            return {
                ...state,
                commentModerationFilterLoading: false,
                commentModerationFilterData: action.payload,
            };
        },
        getCommentModerationFilterFailure(state, action) {
            return {
                ...state,
                commentModerationFilterLoading: false,
                commentModerationFilterError: action.payload,
            };
        },

        //comment moderation filter
        getCommentModerationListLoading(state, action) {
            return {
                ...state,
                commentModerationListLoading: true,
            };
        },
        getCommentModerationListSuccess(state, action) {
            return {
                ...state,
                commentModerationListLoading: false,
                commentModerationListData: action.payload,
            };
        },
        getCommentModerationListFailure(state, action) {
            return {
                ...state,
                commentModerationListLoading: false,
                commentModerationListError: action.payload,
            };
        },

         //comment moderation edit
         getCommentModerationEditLoading(state, action) {
            return {
                ...state,
                commentModerationEditLoading: true,
            };
        },
        getCommentModerationEditSuccess(state, action) {
            return {
                ...state,
                commentModerationEditLoading: false,
                commentModerationEditData: action.payload,
            };
        },
        getCommentModerationEditFailure(state, action) {
            return {
                ...state,
                commentModerationEditLoading: false,
                commentModerationEditError: action.payload,
            };
        },

         //comment moderation submit
         putCommentModerationSubmitLoading(state, action) {
            return {
                ...state,
                commentModerationSubmitLoading: true,
            };
        },
        putCommentModerationSubmitSuccess(state, action) {
            return {
                ...state,
                commentModerationSubmitLoading: false,
                commentModerationSubmitData: action.payload,
            };
        },
        putCommentModerationSubmitFailure(state, action) {
            return {
                ...state,
                commentModerationSubmitLoading: false,
                commentModerationSubmitError: action.payload,
            };
        },

        // to clear message
        clearMessage(state, action) {
            return {
                ...state,
                message:null,
                commentModerationFilterError : null,
                commentModerationFilterData : null,
                commentModerationListError: null,
                commentModerationListData: null,
                commentModerationEditError: null,
                commentModerationEditData: null,
                commentModerationSubmitError: null,
                commentModerationSubmitData: null,
            };
        },
    },
});
export const {
        getCommentModerationFilterLoading,
        getCommentModerationFilterSuccess,
        getCommentModerationFilterFailure,
    
        getCommentModerationListLoading,
        getCommentModerationListSuccess,
        getCommentModerationListFailure,

        getCommentModerationEditLoading,
        getCommentModerationEditSuccess,
        getCommentModerationEditFailure,

        putCommentModerationSubmitLoading,
        putCommentModerationSubmitSuccess,
        putCommentModerationSubmitFailure,
    
        clearMessage,
    
    } = commentModerationSlice.actions;
    
    export default commentModerationSlice.reducer;